import {Children, cloneElement, isValidElement} from "react";

export default function DataSpreader({children, data = {}, ...otherData}) {

    const lastData = data ? data.data : {};

    return (
        <>
            {
                Children.map(children, child => {
                    if (isValidElement(child)) {
                        return cloneElement(child, { data: lastData, ...otherData })
                    }
                    return child
                })
            }
        </>
    )
}
